export function validarCPF(cpf) {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

  let soma = 0;
  for (let i = 0; i < 9; i++) soma += +cpf.charAt(i) * (10 - i);
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== +cpf.charAt(9)) return false;

  soma = 0;
  for (let i = 0; i < 10; i++) soma += +cpf.charAt(i) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  return resto === +cpf.charAt(10);
}

export function validarCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^A-Z0-9]+/g, '');
  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += (+numeros.charAt(tamanho - i).charCodeAt(0) - '0'.charCodeAt(0)) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== +digitos.charAt(0)) return false;

  tamanho++;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += (+numeros.charAt(tamanho - i).charCodeAt(0) - '0'.charCodeAt(0)) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  return resultado === +digitos.charAt(1);
}

export function validarCpfCnpj(valor) {
  const apenasAlfanumericos = valor.replace(/[^A-Z0-9]/g, '');
  if (apenasAlfanumericos.length === 11) return validarCPF(apenasAlfanumericos);
  if (apenasAlfanumericos.length === 14) return validarCNPJ(apenasAlfanumericos);
  return false;
}
